import React, { useState, useEffect } from 'react';
import { Link, Router,useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Container, Button, ModalHeader, ModalFooter, Modal, ModalBody } from "reactstrap";
import Top from '../Top';
import QuickActionsSidebar from '../DistributorDashboard/QuickActionsSidebar';
import { getAdminActions } from '../../../config/actions';
import { API_URL } from '../../../config';
import right from '../../images/right.png';
import {Multiselect } from 'multiselect-react-dropdown';
import "./Announcements.css";



const Announcements = () => {
 

  const [uploadingHeadline, setUploadingHeadline] = useState('')
  const [softwareLink, setSoftwareLink] = useState('');
  const [software, setSoftware] = useState('');
  const [updateSoftware, setUpdateSoftware] = useState('');
  const [uploadContent, setUploadContent] = useState('');
  const [ softwareSource, setSoftwareSource] = useState();
  const [osType,setOsType] = useState('');
  const [Loader, setLoader] = useState(false);
  const [fillallfieldmodal, setFillallfieldModal] = useState(false);
  const fillallfieldtoggleModal = () => setFillallfieldModal(!fillallfieldmodal);
  const [emailalreadyExitmodal, setEmailalreadyExitmodal] = useState(false);
  const EmailalreadyExittoggleModal = () => setEmailalreadyExitmodal(!emailalreadyExitmodal);
  const [error, setError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const { id } = useParams();
  const [editData, setEditData] = useState(['']);
  const [linkErr, setLinkErr] = useState(false);

  const [uploadingHeadlineErr, setUploadingHeadlineErr] = useState(false)
  const [chooseReciepientErr, setChooseReciepientErr] = useState(false)
  const [attachmentTypeErr, setAttachmentTypeErr] = useState(false)
  const [attachmentErr, setAttachmentErr] = useState(false)
  const [distributorListErr, setDistributorListErr] = useState(false)
  const [customerListErr, setCustomerListErr] = useState(false)
  const [updateSoftwareErr, setUpdateSoftwareErr] = useState(false);
  const [uploadContentErr, setUploadContentErr] = useState(false);
  const [ softwareSourceErr, setSoftwareSourceErr] = useState(false);
  const [osTypeErr,setOsTypeErr] = useState(false);
  const [softwareLinkErr, setSoftwareLinkErr] = useState(false);
  const [softwareErr, setSoftwareErr] = useState(false);
  const [errMessage,setErrMessage] = useState('')
  const [recordingVideo, setRecordingVideo] = useState('')
  const [chooseReciepient, setChooseReciepient] = useState('');
  const [attachmentType, setAttachmentType] = useState('');
  const [attachment, setAttachment] = useState();
  const [getDistributor, setGetDistributor] = useState([]);
  const [getCustomer, setGetCustomer] = useState([]);
  const [distributorList, setDistributorList] = useState([])
  const [customerList, setCustomerList] = useState([])
  const [downloaderModal, setDownloaderModal] = useState(false);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const DownloaderToggleModal = () => setDownloaderModal(!downloaderModal);

  
  useEffect(() => {
    getDistrbitorList()
    getCustomerList()
    if(id){
      getEditData();
    }

  }, [])

  const getEditData = () => {
    fetch(API_URL + "/get/software/data/by/" + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setEditData(resp.data);
          if(id){
            setUploadingHeadline(resp.data[0].headline);
            setUploadContent(resp.data[0].content)
            setUpdateSoftware(resp.data[0].software_exe)
          }

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const getDistrbitorList = () => {
    fetch(API_URL + "/get/all/distributer" ,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          let _temp = [];
          resp.data.map((v, i) => {
              _temp.push({name: v.firstname + " " + v.lastname,id:v.id})
          })
          setGetDistributor(_temp);
        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const getCustomerList = () => {
    fetch(API_URL + "/get/all/customer/list" ,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          let _temp = [];
          resp.data.map((v, i) => {
            if(v.firstname == null){

            }else{
              _temp.push({name: v.firstname + " " + v.lastname,id:v.id})
            }
          })
          setGetCustomer(_temp);
        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const handleChooseReciepient = (e) => {
   setChooseReciepient(e.target.value);
  }
  const handleAttachmentType = (e) => {
    setAttachmentType(e.target.value);
  }
  const createProfile = () => {
    debugger
      if(isValid()){
        setDownloaderModal(true)
      
        const data = new FormData();
        data.append("subject", uploadingHeadline);
        data.append("Choose_Recipient", chooseReciepient);
        data.append("content", uploadContent);
        data.append("AttachmentType", attachmentType);
        data.append("form", attachment);
        console.log(attachment ,"field uploaded")
        data.append("Distributor", chooseReciepient == 4 ?  distributorList : '');
        data.append("Customer", chooseReciepient == 5 ?  customerList : '');
   
      // let data = {};
      // data['subject'] = uploadingHeadline;
      // data['Choose_Recipient'] = chooseReciepient;
      // data['content'] = uploadContent;
      // {chooseReciepient == 4 ? data['Distributor'] = distributorList : ''}
      // {chooseReciepient == 5 ? data['Customer'] = customerList : ''}
      // data['AttachmentType'] = attachmentType;
      // data['form'] = attachment;
     
      //  fetch(API_URL + "/create/send/email/announcement/test/url", {                  //test purpose
       fetch(API_URL + "/create/send/email/announcement", {               // for live 
         method: 'POST',
         body: data,   
       }).then((response) => {
         if (response.status == 200) {
           response.json().then((resp) => {
            setDownloaderModal(false)
             successToggleModal();
             setLoader(false)
   
           });
   
         }
         else if (response.status == 400) {
           setLoader(false)
         }
         else if (response.status == 401) {
           logout()
         }
         else {
           console.log("network error")
         }
   
   
       })
      }else {
        return false
      }

  }
  const navigate = useNavigate()


  const handleGoBack = () => {
    if(id){
      navigate('/edit-software');
    }else{
    navigate('/software-update');

    }
  }
  const  isCSVFile = (file) => {
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (fileExtension !== 'csv') {
      return false;
    }
  
    // const reader = new FileReader();
    // reader.readAsText(file);
    // reader.onload = function (event) {
    //   const csvContent = event.target.result;
    //   const isCSVFormat = csvContent.startsWith('data:text/csv');
    //   if (!isCSVFormat) {
    //     return false;
    //   }
    // };
  
    return true;
  }
  function isPDFFile(file) {
    if (file.type === 'application/pdf') {
      return true;
    }
  
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension === 'pdf';
  }
  function isExcelFile(file) {
    if (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      return true;
    }
  
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension === 'xls' || fileExtension === 'xlsx';
  }
  function isTextFile(file) {
    if (file.type === 'text/plain') {
      return true;
    }
  
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension === 'txt';
  }
  function isImageFile(file) {
    debugger
    // if (file.startsWith('image/')) {
    //   return true;
    // }
  
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp']; 
    return imageExtensions.includes(fileExtension);
  }
  // const   isValid = () =>{
  //   debugger
  //   if(uploadingHeadline == '' && chooseReciepient == '' && uploadContent == '' && attachmentType == '' && attachment == ''){
  //     setUploadingHeadlineErr(true)
  //     setChooseReciepientErr(true)
  //     setUploadContentErr(true)
  //     setAttachmentTypeErr(true)
  //     setAttachmentErr(true)
  //     setErrMessage("Field required")
  //   }else if(uploadingHeadline.trim() == ''){
  //     setUploadingHeadlineErr(true)
  //     setChooseReciepientErr(false)
  //     setUploadContentErr(false)
  //     setAttachmentTypeErr(false)
  //     setAttachmentErr(false)
  //     setErrMessage("Field required")
  //   }else if(chooseReciepient == ''){
  //     setUploadingHeadlineErr(false)
  //     setChooseReciepientErr(true)
  //     setUploadContentErr(false)
  //     setAttachmentTypeErr(false)
  //     setAttachmentErr(false)
  //     setErrMessage("Field required")
  //   }else if(chooseReciepient == '4' && distributorList.length == 0){
  //       setUploadingHeadlineErr(false)
  //       setChooseReciepientErr(false)
  //       setUploadContentErr(false)
  //       setAttachmentTypeErr(false)
  //       setAttachmentErr(false)
  //       setDistributorListErr(true)
  //       setCustomerListErr(false)
  //       setErrMessage("Field required")
  //     }else if(chooseReciepient == '5' && customerList.length == 0){
  //       setUploadingHeadlineErr(false)
  //       setChooseReciepientErr(false)
  //       setUploadContentErr(false)
  //       setAttachmentTypeErr(false)
  //       setAttachmentErr(false)
  //       setDistributorListErr(false)
  //       setCustomerListErr(true)
  //       setErrMessage("Field required")
  //     }
  //   else if(uploadContent.trim() == ''){
  //     setUploadingHeadlineErr(false)
  //     setChooseReciepientErr(false)
  //     setUploadContentErr(true)
  //     setAttachmentTypeErr(false)
  //     setAttachmentErr(false)
  //     setDistributorListErr(false)
  //       setCustomerListErr(false)
  //     setErrMessage("Field required")
  //   }
  //   else if(attachmentType != ''){
  //     if(attachmentType == '1'){
  //       if(isCSVFile(attachment)){
  //         return true
  //       }else{
  //         setUploadingHeadlineErr(false)
  //     setChooseReciepientErr(false)
  //     setUploadContentErr(false)
  //     setAttachmentTypeErr(false)
  //     setAttachmentErr(true)
  //     setErrMessage("Choose valid file")
  //     return false
  //       }
  //     }else if(attachmentType == '2'){
  //       if(isPDFFile(attachment)){
  //         return true
  //       }else{
  //         setUploadingHeadlineErr(false)
  //     setChooseReciepientErr(false)
  //     setUploadContentErr(false)
  //     setAttachmentTypeErr(false)
  //     setAttachmentErr(true)
  //     setErrMessage("Choose valid file")
  //     return false
  //       }

  //     }else if(attachmentType == '3'){
  //       if(isExcelFile(attachment)){
  //         return true
  //       }else{
  //         setUploadingHeadlineErr(false)
  //         setChooseReciepientErr(false)
  //         setUploadContentErr(false)
  //         setAttachmentTypeErr(false)
  //         setAttachmentErr(true)
  //         setErrMessage("Choose valid file")
  //         return false
  //       }

  //     }else if(attachmentType == '4'){
  //       if(isTextFile(attachment)){
  //         return true
  //       }else{
  //         setUploadingHeadlineErr(false)
  //         setChooseReciepientErr(false)
  //         setUploadContentErr(false)
  //         setAttachmentTypeErr(false)
  //         setAttachmentErr(true)
  //         setErrMessage("Choose valid file")
  //         return false
  //       }

  //     }else if(attachmentType == '5'){
  //       if(isImageFile(attachment)){
  //         return true
  //       }else{
  //         setUploadingHeadlineErr(false)
  //         setChooseReciepientErr(false)
  //         setUploadContentErr(false)
  //         setAttachmentTypeErr(false)
  //         setAttachmentErr(true)
  //         setErrMessage("Choose valid file")
  //         return false
  //       }
  //     }
  //   }
  //   else{
  //     setUploadingHeadlineErr(false)
  //     setChooseReciepientErr(false)
  //     setUploadContentErr(false)
  //     setAttachmentTypeErr(false)
  //     setAttachmentErr(false)
  //     return true
  //   }
  // }

  const isValid = () =>{
    debugger
    // if(uploadingHeadline.trim().length == 0 || chooseReciepient.length == 0 || uploadContent.trim().length==0){
    //   if(chooseReciepient == '4'|| distributorList.length==0){
    //     debugger

    //     fillallfieldtoggleModal();
    //     return false;
    //   }else if(chooseReciepient == '4'|| customerList.length==0){
    //             fillallfieldtoggleModal();
    //     return false;
    //   }else{
    //   return true;  
    //   }
    // }else{
    //   return true;
    // }
    if(uploadingHeadline.trim().length == 0){
        fillallfieldtoggleModal();
        return false;
    }else if(chooseReciepient == ''){
      fillallfieldtoggleModal();
        return false;
    }else if(chooseReciepient == '0'){
      fillallfieldtoggleModal();
        return false;
    }else if(chooseReciepient == '4' && distributorList.length == 0){
        fillallfieldtoggleModal();
        return false;
    }else if(chooseReciepient == '5' && customerList.length == 0){
        fillallfieldtoggleModal();
        return false;
    }else if(uploadContent.trim().length==0){
      fillallfieldtoggleModal();
        return false;
    }else if(attachmentType != ''){
      if(attachmentType == '1'){
        if( attachment != undefined && isCSVFile(attachment)){
          return true
        }else{
          fillallfieldtoggleModal();
          return false;
        }
      }else if(attachmentType == '2'){
        if(attachment != undefined && isPDFFile(attachment)){
          return true
        }else{
          fillallfieldtoggleModal();
          return false;
        }

      }else if(attachmentType == '3'){
        if(attachment != undefined && isExcelFile(attachment)){
          return true
        }else{
          fillallfieldtoggleModal();
          return false;
        }

      }else if(attachmentType == '4'){
        if(attachment != undefined && isTextFile(attachment)){
          return true
        }else{
          fillallfieldtoggleModal();
          return false;
        }

      }else if(attachmentType == '5'){
        if(attachment != undefined && isImageFile(attachment)){
          return true
        }else{
          fillallfieldtoggleModal();
          return false;
        }
    //  else if(attachmentType != ''){ }
    }
    else{
      return true;
    }
  }
}


 
  const handleChangeDistributor = (e)=>{
    e.map((item, i )=>{
      if(distributorList.includes(item.id)){
      }else{
        distributorList.push(item.id)
    }
    })
  }
  const handleChangeCustomer = (e)=>{
    e.map((item, i )=>{
      if(customerList.includes(item.id)){
  
      }else{
  
      
        customerList.push(item.id)
    }
    })
  }
  const handleAttachmentFile = (event) =>{
    setAttachment(event.target.files[0]);
    setAttachmentErr(false)
  }

  const uid = localStorage.getItem("uid");
  const userId = localStorage.getItem("user_id");

  const adminActions = getAdminActions("7", userId);

  return (
    <div className="announcements-container">
      <div className="announcements-dashboard">
        <QuickActionsSidebar actions={adminActions} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu} />
        <div className="announcements-content">
        <div className="head-listing head-listingb">
                            <h3>Email Announcement</h3>
                        </div>
          <div className='right-section-box'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Email Subject* </label>
                  <input type="text" value={uploadingHeadline}  onChange={(e) => setUploadingHeadline(e.target.value)} className='client-input' placeholder='Enter subject' />
              {uploadingHeadlineErr ? <div className='linkError'>{errMessage}</div>:""}

                </div>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Choose Reciepient*</label>
                  <select onChange={handleChooseReciepient}  className='client-input' placeholder='Choose Country'>
                    <option value="0">Select Reciepient</option>
                    <option value="1" selected={1 ? editData[0].sw_type:''}>All Distributors & All Customers</option>
                    <option value="2" selected={2 ? editData[0].sw_type:''}>All Distributors</option>
                    <option value="3" selected={2 ? editData[0].sw_type:''}>All Customers</option>
                    <option value="4" selected={2 ? editData[0].sw_type:''}>Single/Group Distributors</option>
                    <option value="5" selected={2 ? editData[0].sw_type:''}>Single/Group Customers</option>

                  </select>
                  {chooseReciepientErr ? <div className='linkError'>{errMessage}</div>:""}
                  </div>
                  {chooseReciepient == 4 ?<div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Distributor List*</label>
                  <Multiselect options={getDistributor} displayValue="name" onSelect={handleChangeDistributor}  />
                  {distributorListErr ? <div className='linkError'>{errMessage}</div>:""}
                  </div>:""}
                  {chooseReciepient == 5 ?<div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Customer List*</label>
                  <Multiselect options={getCustomer} displayValue="name" onSelect={handleChangeCustomer}  />
                  {customerListErr ? <div className='linkError'>{errMessage}</div>:""}
                  </div>:""}

              </div>
              

            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Email Content*</label>
                  <textarea type="textarea" rows='1' cols='52' name='address' value={uploadContent} onChange={(e) => setUploadContent(e.target.value)}style={{height:'185px'}} className='client-input' />
                  {uploadContentErr ? <div className='linkError'>{errMessage}</div>:""}
                  </div>
              </div>
            </div>


            <div className='col-lg-12'>
              <div className='row'>

                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Email Attachment Type</label>
                  <select onChange={handleAttachmentType}  className='client-input' placeholder='Choose Country'>
                    <option value="0">Select Attachment Type</option>
                    <option value="1" selected={1 ? editData[0].sw_type:''}>CSV</option>
                    <option value="2" selected={2 ? editData[0].sw_type:''}>PDF</option>
                    <option value="3" selected={2 ? editData[0].sw_type:''}>Excel</option>
                    <option value="4" selected={2 ? editData[0].sw_type:''}>Text</option>
                    <option value="5" selected={2 ? editData[0].sw_type:''}>Image</option>

                  </select>
                  {attachmentTypeErr ? <div className='linkError'>{errMessage}</div>:""}
                  </div>

                 {softwareSource == 1 ? <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Software Link* </label>
                  <input type="text" value={softwareLink}  onChange={(e) => setSoftwareLink(e.target.value)} className='client-input' placeholder='Enter headline' />
                  {softwareLinkErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>
              </div>
            </div> :''}
            {softwareSource == 2 ? <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Software*</label>
                  <input type="file" value={software}  onChange={(e) => setSoftware(e.target.value)} className='client-input' placeholder='Enter headline' />
                  {softwareErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>
              </div>
            </div> : ''}

              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>

                  <div className='form-group col-lg-12 no-padding'>
                  <label className='control-label'>Email Attachment</label>
                  <input type="file" accept={attachmentType == 1 ? "text/csv":attachmentType == 2 ?"application/pdf":attachmentType == 3? 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':attachmentType == 4? 'text/plain':attachmentType == 5?'image/*':''} onChange={(e)=>handleAttachmentFile(e)} className='client-input' placeholder='Enter link' />
                  {/* <input type="file" value={attachment} onChange={(e) => {setAttachment(e.target.files[0]);setAttachmentErr(false)}} className='client-input' placeholder='Enter link' /> */}
                  {attachmentErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>

              </div>
            </div>
           {id ? <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Update Software* </label>
                  <input type="text" value={updateSoftware}  onChange={(e) => setUpdateSoftware(e.target.value)} className='client-input' placeholder='Enter headline' />
              {linkErr ? <div className='linkError'>Enter valid link</div>:""}


                </div>
              </div>

            </div> : ''}

            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>
                 <button type="submit" className='btn btn-primary_d' onClick={createProfile}>Send
                    {
                      Loader &&
                      <div id="loader"></div>
                    }
                  </button>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <Modal isOpen={downloaderModal} toggle={DownloaderToggleModal} className="connect-box" centered={true}>
                            <ModalHeader toggle={DownloaderToggleModal}><span className="ml-1 roititle font-weight-bold">Request processing...</span></ModalHeader>
                            <ModalBody>
                            <div className="modal-p">
                                <p className='text-center'>Please wait...</p>
                                <div v-if="loading" className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>
      </div>
                            </ModalBody>

                        </Modal>



      <Modal isOpen={fillallfieldmodal} toggle={fillallfieldtoggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={fillallfieldtoggleModal}><span className="ml-1 roititle font-weight-bold">Error</span></ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Please fill all required field</p>
          </div>
        </ModalBody>

      </Modal>

      <Modal isOpen={emailalreadyExitmodal} toggle={EmailalreadyExittoggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={EmailalreadyExittoggleModal}><span className="ml-1 roititle font-weight-bold">Error</span></ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Distributor already exist with this email</p>
          </div>
        </ModalBody>

      </Modal>

      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            {/* <h4>{id?"Sent":"Created"}</h4> */}
            <h4>Sent</h4>
            <p>Email has been Sent successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </div>
  );
};

export default Announcements;
  
